__turbopack_context__.v({
  "axis": "MatrixLoader-module__V2lZTa__axis",
  "edge": "MatrixLoader-module__V2lZTa__edge",
  "far": "MatrixLoader-module__V2lZTa__far",
  "inner": "MatrixLoader-module__V2lZTa__inner",
  "loader": "MatrixLoader-module__V2lZTa__loader",
  "od-matrix-axis": "MatrixLoader-module__V2lZTa__od-matrix-axis",
  "od-matrix-edge": "MatrixLoader-module__V2lZTa__od-matrix-edge",
  "od-matrix-far": "MatrixLoader-module__V2lZTa__od-matrix-far",
  "od-matrix-inner": "MatrixLoader-module__V2lZTa__od-matrix-inner",
});
